export default function getProfileParser() {
  const worker = new Worker(
    new URL('./profile-parser.worker.js', import.meta.url)
  )

  return {
    parse(data) {
      return new Promise((res, rej) => {
        worker.onmessage = e => {
          if (e.data && e.data.error) {
            rej(e.data.error)
            return
          }

          res(e.data)
        }

        worker.postMessage({
          key: 'parse',
          value: data,
        })
      })
    },
    parseMachineLists(data) {
      return new Promise((res, rej) => {
        worker.onmessage = e => {
          if (e.data && e.data.error) {
            rej(e.data.error)
            return
          }

          res(e.data)
        }

        worker.postMessage({
          key: 'parseMachineLists',
          value: data,
        })
      })
    },
    getOptionsFromProfile(data) {
      return new Promise((res, rej) => {
        worker.onmessage = e => {
          if (e.data && e.data.error) {
            rej(e.data.error)
            return
          }

          res(e.data)
        }

        worker.postMessage({
          key: 'getOptionsFromProfile',
          value: data,
        })
      })
    },
  }
}
